import React from "react";
import { CodedProperty, LabeledText, NamedProperty, Stack, Text } from "sprint-common-web";

import { getLanguageDisplayName } from "../../../common/types/Language";

type VideoDetailsInfoProps = {
    aspectRatio?: NamedProperty;
    aspectType?: NamedProperty;
    subtitle?: CodedProperty;
    testId?: string;
};

export const VideoDetailsInfo = (props: VideoDetailsInfoProps): JSX.Element => {
    const { subtitle, aspectRatio, aspectType, testId } = props;

    if (!subtitle && !aspectRatio) return <Text variant="small">-</Text>;

    return (
        <Stack data-testId={testId}>
            {!!subtitle && (
                <LabeledText
                    direction="horizontal"
                    textFontSize={12}
                    labelFontSize={12}
                    label="Embedded subtitle:"
                    value={getLanguageDisplayName(subtitle)}
                    testId="subtitle"
                />
            )}
            {!!aspectRatio && (
                <LabeledText
                    direction="horizontal"
                    textFontSize={12}
                    labelFontSize={12}
                    label="Aspect ratio:"
                    value={aspectRatio?.name}
                    testId="aspect-ratio"
                />
            )}
            {!!aspectType && (
                <LabeledText
                    direction="horizontal"
                    textFontSize={12}
                    labelFontSize={12}
                    label="Aspect type:"
                    value={aspectType?.name}
                    testId="aspect-type"
                />
            )}
        </Stack>
    );
};
